import { render } from "./NatProjects.vue?vue&type=template&id=6df0fefc&scoped=true"
const script = {}

import "./NatProjects.vue?vue&type=style&index=0&id=6df0fefc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6df0fefc"

export default script